/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useState, useEffect, useContext } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import { useNavigate } from 'react-router-dom';
import Loading from '../../Loading';
import { useTranslation } from 'react-i18next';

const CancelReasonsList = [
    { id: '1', title: 'Financing fell through' },
    { id: '2', title: 'Inspection issues' },
    { id: '3', title: 'Change in financial situation' },
    { id: '4', title: 'Title issues' },
    { id: '5', title: 'Seller changes their mind' },
    { id: '6', title: 'Competing offer' },
    { id: '7', title: 'Personal Reasons' },
    { id: '8', title: 'Others' },
];

const Booking = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);

    const [selectButton, setSelectButton] = useState("Active");
    const [bookingData, setBookingData] = useState([]);
    const [showCancelBox, setShowCancelBox] = useState(false);
    const [selectReason, setSelectReason] = useState();
    const [otherReason, setOtherReason] = useState();
    const [ticketId, setTicketId] = useState("");
    const [loading, setLoading] = useState(true);

    const Navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        HandleFechData();
    }, [selectButton]);

    const HandleFechData = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${BaseUrl}user_api/ticket_status_wise.php`, { uid: Userid, status: selectButton })
                .then((res) => {
                    console.log("ticket_status_wise", res);
                    setBookingData(res.data.order_data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("ticket_status_wise", error);
                });
        }
    };

    const HandleCancelBooking = () => {
        const Error = selectReason?.id === "8" ? otherReason : selectReason?.title;

        if (!Error) {
            showTost(t("Select Cancel Reason !!"), "error");
            return;
        }

        const Userid = localStorage.getItem("Userid");

        axios.post(`${BaseUrl}user_api/ticket_cancle.php`, { uid: Userid, ticket_id: ticketId, cancle_comment: Error })
            .then((res) => {
                console.log("ticket_cancle", res);
                if (res.data.ResponseCode === "200") {
                    setShowCancelBox(false);
                    showTost(res.data.ResponseMsg, "success");
                }
            })
            .catch((error) => {
                console.error("ticket_cancle", error);
            });

    };

    const HandleNavigate = (e, index, item) => {
        e.stopPropagation();

        if (index === 0) {
            Navigate("/event-details");
            sessionStorage.setItem("Eventid", item);
        } else {
            Navigate("/e-ticket", { state: { Ticketdata: item, type: selectButton } });
        }
    };

    return (
        <div className="width_container">
            <div className="">
                <div className="mb-[20px]">
                    <h1 className='font-bold text-[30px]'>{t("Bookings")}</h1>
                    <span className='text-gray-500'>{t("You added")} {bookingData?.length} {t("items to")} {t("bookings")}</span>
                </div>
                <div className="flex justify-center rounded-[20px] mb-[30px] mt-[20px]">
                    <div className="bg-white inline-block rounded-[50px] px-[10px] py-[10px]">
                        <div className="flex items-center gap-[20px]">
                            <button onClick={() => setSelectButton("Active")} className={`${selectButton === "Active" && "booking-active"} booking-button max-_430_:text-[16px]`}>{t("Active")}</button>
                            <button onClick={() => setSelectButton("Completed")} className={`${selectButton === "Completed" && "booking-active"} booking-button max-_430_:text-[16px]`}>{t("Completed")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="booking">
                {bookingData.length >= 1
                    ? bookingData.map((item, index) => {
                        return <div onClick={(e) => HandleNavigate(e, 0, item.event_id)} key={index} className="box">
                            <div className="w-[100%] h-[300px] overflow-hidden">
                                <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover hover:scale-[1.1] duration-[0.5s]" alt="" />
                            </div>
                            <div className="type_box">{item.ticket_type}</div>
                            <div className="px-[15px] py-[20px] bg-white">
                                <h1 className>{item.event_title}</h1>
                                <p className="text-gray-600 text-[14px] mt-[10px] mb-[15px]">{item.event_place_name}</p>
                                <div className="border-t-[1px]"></div>
                                <div className="pt-[15px] flex items-center justify-between">
                                    <h1 className="font-bold text-[14px]">{item.event_sdate}</h1>
                                    <div className="flex items-center gap-[10px]">
                                        {(selectButton === "Active" && item.book_mintues <= 10) && <button onClick={(e) => { e.stopPropagation(); setShowCancelBox(true); setTicketId(item.ticket_id) }} className="font-bold text-[14px] text-[red]">{t("Cancel")}</button>}
                                        <button onClick={(e) => HandleNavigate(e, 1, item)} className="text-[15px] text-gray-700 font-bold border-[2px] px-[10px] py-[5px] rounded-[5px]">{t("View E-Ticket")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : <div className="w-[100%] h-[200px] flex items-center justify-center">
                        <h1 className="font-bold text-gray-600">{t("Go & Book your favorite Event !!")}</h1>
                    </div>}
            </div>

            {showCancelBox && <div onClick={() => setShowCancelBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="coupon_box">
                    <h1 className="font-bold text-[20px]">{t("Select Reason")}</h1>
                    <p className="text-[15px] text-gray-600">{t("Please select the reason for cancellation")}</p>
                    <div className="mt-[10px]">
                        {CancelReasonsList.map((item, index) => {
                            return <div onClick={() => setSelectReason(item)} key={index} className="cursor-pointer flex items-center gap-[10px]">
                                <div className="w-[20px] h-[20px] border-[2px] rounded-[100%] p-[3px]">
                                    <span className={`reason ${selectReason?.id === item.id && "resone_select"}`}></span>
                                </div>
                                <h1 className="py-[8px]">{t(item.title)}</h1>
                            </div>
                        })}
                        {selectReason?.id === "8" && <input onChange={(e) => setOtherReason(e.target.value)} value={otherReason} className="border-[1px] w-[100%] py-[8px] px-[10px] rounded-[8px] text-[15px] focus-within:outline-[#0000ffb7]" type="text" placeholder={t('Enter Other Reason')} />}
                    </div>
                    <div className="flex items-center gap-[10px] mt-[10px]">
                        <button onClick={() => setShowCancelBox(false)} className="w-[100%] bg-red-500 hover:bg-red-400  p-[10px] rounded-[10px] text-white font-bold">{t("Cancel")}</button>
                        <button onClick={HandleCancelBooking} style={{ margin: "0" }} className="button">{t("Confirm")}</button>
                    </div>
                </div>
            </div>}

            {loading && <Loading />}

        </div>
    )
}

export default Booking
/* jshint ignore:end */